import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getKhattabatStore from "../../../stores/khattabat-stores";
import getKhattabat101CStore from "../../../stores/khattabat-stores/101c-stores/index";
import getKhattabatSharedMessagingStore from "../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const KhattabatClientChevron = withLiteObserverAndTheme<{
  userID: number;
}>((props) => {
  const { userID } = props;
  const { oneOOneCId, shouldShowConversation, closeClientConversation } =
    getKhattabat101CStore(userID);
  const unreadMessagesCounter = getKhattabatSharedMessagingStore(
    oneOOneCId.get()
  ).unreadMessagesCounter.get();
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();
  const shouldShowConversations = shouldShowConversation.get();

  return (
    <IconButton
      aria-label={i18n.get("KHATTABAT_CLIENT_TOGGLE_CONVERSATIONS")}
      aria-expanded={shouldShowConversations}
      color="primary"
      sx={{ alignSelf: "center", mx: 1 }}
      onClick={() =>
        shouldShowConversations
          ? closeClientConversation()
          : getKhattabatStore().getClientConversation({
              userID,
              shouldLoad: true
            })
      }
    >
      <Badge
        color="error"
        badgeContent={unreadMessagesCounter}
        invisible={isAiKhattaba || !isPositiveNumber(unreadMessagesCounter)}
      >
        {shouldShowConversations ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Badge>
    </IconButton>
  );
});

export default KhattabatClientChevron;
